import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export interface UpdateCompanyForm {
  /** 서비스 이름 */
  serviceName: string;
  /** 웹사이트 */
  website: string;
  /** vc 투자 여부 */
  hasVcInvestment: string;
  /** 누적 투자금 */
  totalInvestmentAmount: string;
  name: string;
  address: string;
  addressDetail: string;
  taxRegistrationNo: string;
  bzdNo: string;
  btpNo: string;
  korRepresentativeName: string;
  taxContacts: {
    name: string;
    email: string;
  }[];
}

/**
 * 회사정보 업데이트
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/company-controller/getCompanyDetail
 *
 * @param companyId
 * @param form
 * @returns
 */
export default async function updateCompany(companyId: string, form: Partial<UpdateCompanyForm>) {
  const response = await API.patch<ResponseBaseWithData>(`/api/v2/companies/${companyId}`, {
    data: form,
  });

  return response;
}
